module.exports = __webpack_public_path__ + "img/file-pdf.02912989.svg";